import { 
  FETCHING_LIVE_ELEMENTS_REQUEST, FETCHING_LIVE_ELEMENTS_SUCCEEDED, FETCHING_LIVE_ELEMENTS_FAILED, 
  CREATE_LIVE_ELEMENT_REQUEST, CREATING_LIVE_ELEMENT_SUCCEEDED, CREATING_LIVE_ELEMENT_FAILED,
  FETCHING_LIVE_ELEMENT_REQUEST, FETCHING_LIVE_ELEMENT_SUCCEEDED, FETCHING_LIVE_ELEMENT_FAILED, INVALIDATE_LIVE_ELEMENT,
  DELETE_LIVE_ELEMENT_REQUEST, DELETING_LIVE_ELEMENT_SUCCEEDED, DELETING_LIVE_ELEMENT_FAILED,
  UPDATE_LIVE_ELEMENT_REQUEST, UPDATING_LIVE_ELEMENT_SUCCEEDED, UPDATING_LIVE_ELEMENT_FAILED,
  RENAME_LIVE_ELEMENT_REQUEST,
  PUBLISH_LIVE_ELEMENT_REQUEST, PUBLISHING_LIVE_ELEMENT_SUCCEEDED, PUBLISHING_LIVE_ELEMENT_FAILED, CLONE_LIVE_ELEMENT_REQUEST, CLONING_LIVE_ELEMENT_SUCCEEDED, CLONING_LIVE_ELEMENT_FAILED
} from "constants/actionTypes";

import _ from 'lodash';
import { nullFormat } from "numeral";

const initialState = {
  loading: false,
  invalidated: false,
  items: [],
  delete: {
    id: null,
    deleting: false,
    deleted: false
  },
  liveElement: {
    item: null,
    loading: false,
    create: {
      id: null,
      creating: false,
      created: false,
      error: null
    },
    update: {
      id: null,
      updating: false,
      updated: false,
      error: null
    },
    publish: {
      id: null,
      publishing: false,
      published: false,
      error: null
    },
    clone: {
      id: null,
      cloning: false,
      cloned: false,
      error: null
    },
    invalidated: false
  },
  pagination: {
    current: -1,
    totalPages: 1
  },

}

export function liveElementsReducer(state = initialState, action) {
  switch (action.type) {

    case FETCHING_LIVE_ELEMENTS_REQUEST:
      const { page } = action.payload;

      if (page === 0) {
        return {
          ...state,
          loading: true,
          items: [],
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: 0
          }
        }
      }

      return {
        ...state,
        loading: true
      }

    case FETCHING_LIVE_ELEMENTS_SUCCEEDED: {
      var items = state.items || [];
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = action.payload;

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id === y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }
    }

    case FETCHING_LIVE_ELEMENTS_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    
    case CREATE_LIVE_ELEMENT_REQUEST: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          create: {
            item: null,
            creating: true,
            created: false,
            error: null
          }
        }
      }
    }
      
    case CREATING_LIVE_ELEMENT_SUCCEEDED: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          create: {
            item: action.payload,
            creating: false,
            created: true,
            error: null
          }
        }
      }
    }
      
    case CREATING_LIVE_ELEMENT_FAILED: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          create: {
            item: null,
            creating: false,
            created: false,
            error: action.payload
          }
        }
      }
    }

    case FETCHING_LIVE_ELEMENT_REQUEST: {
      const id = action.payload;
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          [id]: {
            loading: true,
            item: null
          }
        }
      }
    }

    case FETCHING_LIVE_ELEMENT_SUCCEEDED: {
      const liveElement = action.payload;
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          [liveElement.id]: {
            loading: false,
            item: liveElement
          }
        }
      }
    }

    case FETCHING_LIVE_ELEMENT_FAILED: {
      const { id, error } = action.payload;
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          [id]: {
            loading: false,
            item: null,
            error: error
          }
        }
      }
    }

    case DELETE_LIVE_ELEMENT_REQUEST: {
      const id = action.payload;

      return {
        ...state,
        delete: {
          ...state.delete,
          id: id,
          deleting: true,
          deleted: false
        },
      }
    }

    case DELETING_LIVE_ELEMENT_SUCCEEDED: {
      const { id } = action.payload;

      var items = (state.items || []).filter(item => item.id !== id);

      return {
        ...state,
        items: items,
        delete: {
          ...state.delete,
          id: id,
          deleting: false,
          deleted: true
        }
      }
    }

    case DELETING_LIVE_ELEMENT_FAILED: {
      const { id, error } = action.payload;

      return {
        ...state,
        delete: {
          ...state.delete,
          id: id,
          deleting: false,
          deleted: false,
          error: error
        }
      }
    }

    case UPDATE_LIVE_ELEMENT_REQUEST:
    case RENAME_LIVE_ELEMENT_REQUEST: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          update: {
            ...state.liveElement.item,
            updating: true,
            updated: false,
            error: null
          }
        }
      }
    }
      
    case UPDATING_LIVE_ELEMENT_SUCCEEDED: {
      const {id, response} = action.payload;

      const elementState = state.liveElement[id];
      if(!elementState){
        return state;
      }
      
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          update: {
            updating: false,
            updated: true,
            error: null
          },
          [id]: {
            ...elementState,
            item: response
          }
        }
      }
    }
      
    case UPDATING_LIVE_ELEMENT_FAILED: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          update: {
            updating: false,
            updated: false,
            error: action.payload
          }
        }
      }
    }

    case PUBLISH_LIVE_ELEMENT_REQUEST: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          publish: {
            publishing: true,
            published: false,
            error: null
          }
        }
      }
    }
      
    case PUBLISHING_LIVE_ELEMENT_SUCCEEDED: {
      const {id, response} = action.payload;

      const elementState = state.liveElement[id];
      if(!elementState){
        return state;
      }

      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          publish: {
            publishing: false,
            published: true,
            error: null
          },
          [id]: {
            ...elementState,
            item: response
          }
        }
      }
    }
      
    case PUBLISHING_LIVE_ELEMENT_FAILED: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          publish: {
            publishing: false,
            published: false,
            error: action.payload
          }
        }
      }
    }

    case CLONE_LIVE_ELEMENT_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          clone: {
            id: id,
            cloning: true,
            cloned: false,
            error: null
          }
        }
      }
    }
      
    case CLONING_LIVE_ELEMENT_SUCCEEDED: {
      const {id, response} = action.payload;

      const liveElement = _.get(state, 'liveElement.clone.id');
      if(liveElement !== id){
        return state;
      }

      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          clone: {
            id: id,
            item: response,
            cloning: false,
            cloned: true,
            error: null,
          }
        }
      }
    }
      
    case CLONING_LIVE_ELEMENT_FAILED: {
      const {id, error} = action.payload;

      const liveElement = _.get(state, 'liveElement.clone.id');
      if(liveElement !== id){
        return state;
      }

      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          clone: {
            id: id,
            cloning: false,
            cloned: false,
            error: error,
          }
        }
      }
    }

    case INVALIDATE_LIVE_ELEMENT: {
      return {
        ...state,
        liveElement: {
          ...state.liveElement,
          create: {
            item: null,
            creating: false,
            created: false,
            error: null
          },
          clone: {
            id: null,
            cloning: false,
            cloned: false,
            error: null
          },
          update: {
            updating: false,
            updated: false,
            error: null
          },
          publish: {
            publishing: false,
            published: false,
            error: null
          }
        }
      }
    }
       
    default:
      return state;
  }
}

